// extracted by mini-css-extract-plugin
export default {"primaryColor":"#404f9d","ihGrey":"#23282d","successColor":"#28a745","dangerColor":"#dc3545","backgroundColor":"#f8f9fa"};